var TECL_AutoComplete = {
    increment: 0,
    lastProcessedId: 0,
   acSnippet: '<ul class="ac-dropdown"></ul>',

   RemoveDropdown: function(element) {
      if($(element).next().hasClass('ac-dropdown')) {
         $(element).next().hide(200, function(){ $(element).next().remove() });
      }
   }
   ,
   CreateDropdown: function(element, data) {
       if (!$.isEmptyObject(data.results)) {
           if (parseInt(data.requestId) > parseInt(TECL_AutoComplete.lastProcessedId)) {
               if (!$(element).next().hasClass('ac-dropdown')) {
                   $(element).after(TECL_AutoComplete.acSnippet);
               }

               $(element).next().empty();

               $.each(data.results,
                   function(i, item) {
                       id = item.OrgId;
                       name = item.OrgName;
                       postcode = item.OrgPostcode;
                       $(element).next().append(
                           '<li class="ac-option" data_name="' +
                           name +
                           '" data_id="' +
                           id +
                           '">' +
                           name +
                           '<span class="result-postcode">' +
                           postcode +
                           '</span></li>'
                       );
                   });
               TECL_AutoComplete.lastProcessedId = data.requestId;
           }
       } else {
         $(element).next().empty();
         $(element).next().append(
            '<li class="ac-no-results">No results found</li>'
         );
      }
   }
   ,
   Search: function(element, query) {
       if (query == null) {
           query = "";
       }
       if (query.length >= 2) {
       data = { 'searchString': query, 'requestId': TECL_AutoComplete.increment };
         $.ajax({
            url: "/umbraco/surface/TagsAndMetadataFormSurface/GetOrgQuickSearchResults/",
            data: data,
            success: function(results) {
                TECL_AutoComplete.CreateDropdown(element, results);
            }
         });
         TECL_AutoComplete.increment++;
      }
   }
   ,
   HighlightItemBeneath: function(element) {
      currentHighlightedItem = $(element).next().children('.interested');
      if(currentHighlightedItem.length == 0) {
         $(element).next().children().first().addClass('interested');
      } else {
         currentHighlightedItem.next().addClass('interested');
         currentHighlightedItem.removeClass('interested');
      }
   }
   ,
   HighlightItemAbove: function(element) {
      currentHighlightedItem = $(element).next().children('.interested');
      if(currentHighlightedItem.length == 0) {
         $(element).next().children().first().addClass('interested');
      } else {
         currentHighlightedItem.prev().addClass('interested');
         currentHighlightedItem.removeClass('interested');
      }
   }
   ,
   SelectItem: function(element, valueId, valueName) {     
      $(element).val(valueName);
      $(element).attr('data_id', valueId);
      $(element).attr('data_name', valueName);

      TECL_AutoComplete.TriggerCustomEvent(element);
      TECL_AutoComplete.RemoveDropdown(element);
   }
   ,
   TriggerCustomEvent: function(element) {
      dataId = $(element).attr("data_id");
      dataName = $(element).attr("data_name");
      value = $(element).val();

      if(dataName != value) {
         dataId = "";
         dataName = "";
      }

      $(element).trigger("itemSelected", [dataId, dataName] );
   }
   ,
   Initialise: function(selector) {
      var mouseIsIn;

      $(selector).on("focus", function(e){
         query = $(this).val();
         TECL_AutoComplete.Search(query);
      });

      $(selector).on("blur", function(e){
         if(!mouseIsIn){
            TECL_AutoComplete.RemoveDropdown(this);
         }
      });

      $(selector).on("input propertychange paste", function(){
         $(this).attr('data_id', '');
         $(this).attr('data_name', '');

         query = $(this).val();
         TECL_AutoComplete.Search(this, query);
         TECL_AutoComplete.TriggerCustomEvent(this);
      });

      $(selector).on("keydown", function(e) {
         if(e.keyCode == 40) {
            TECL_AutoComplete.HighlightItemBeneath(this);
         }

         if(e.keyCode == 38) {
            TECL_AutoComplete.HighlightItemAbove(this);
         }

         if(e.keyCode == 13 || e.keyCode == 9) {
            if($(this).next().hasClass('ac-dropdown')) {
               e.preventDefault();
               if($(this).next().find('.interested').length > 0) {
                  valueName = $(this).next().children('.interested').first().attr('data_name');
                  valueId = $(this).next().children('.interested').first().attr('data_id');
                  TECL_AutoComplete.SelectItem(this, valueId, valueName);
               }
            }
         }
      });

      $(document).on("mouseenter", ".ac-dropdown", function(e) {
         mouseIsIn = true;
      });

      $(document).on("mouseleave", ".ac-dropdown", function(e) {
         mouseIsIn = false;
      });

      $(document).on("click", ".ac-option", function(e) {
         valueName = $(this).attr('data_name');
         valueId = $(this).attr('data_id');
         autocomplete = $(this).parent().prev();

         TECL_AutoComplete.SelectItem(autocomplete, valueId, valueName);
        
         $(autocomplete).trigger("itemSelected", [valueId, valueName] );
         TECL_AutoComplete.RemoveDropdown(autocomplete);
      });

      $(document).on("click", ".ac-no-results", function(e) {
         autocomplete = $(this).parent().prev();
         TECL_AutoComplete.RemoveDropdown(autocomplete);
      });
   }
};

TECL_AutoComplete.Initialise($('.autocomplete'));